import React, { useEffect, useState } from "react";
import Section_title from "../../../common-components/section-title/Section_title";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import { Tooltip } from "react-tooltip";
import {
  GetAll,
  GetSingle,
  Update,
  Create,
} from "../../../../features/admin/customer-management/driver/Slice";
import { useDispatch } from "react-redux";
import { set, useForm } from "react-hook-form";
import classNames from "classnames";
import Add from "./Add";
import Pagination_Holder from "../../../common-components/Pagination_Holder/Pagination_Holder";
import Table_search from "../../../common-components/table-search/Table_search";
import { updateDriverStatus } from "../../../../features/admin/customer-management/driver/Slice";
import { formatDate } from "../../../../utils/common";
import { DOWNLOAD_EXCEL } from "../../../../utils/Methods";
import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";
import View_img_Modal from "../../../common-components/common_Modal/view_img_Modal/View_img_Modal";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faInfo,faInfoCircle } from "@fortawesome/free-solid-svg-icons";
const Country = () => {
  const [modalShow, setModalShow] = React.useState(false);
  const [image, setImage] = React.useState("");
  const dispatch = useDispatch();

  const {
    country,
    first_name,
    setName,
    email,
    setemail,
    contact_no,
    setcontact_no,
    pincode,
    setpincode,
    vehicleType,
    setVehicleType,
    fetch,
    deleteData,
    toggleStatus,
  } = IndexUse();

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const vehicleTypeParam = params.get("vehicleType");

    if (vehicleTypeParam) {
      setVehicleType(vehicleTypeParam);
    }
  }, [location.search]);

  useEffect(() => {
    if (vehicleType) {
      fetch(); // run when vehicleType is updated
    }
  }, [vehicleType]);

  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);
  useEffect(() => {
    if (country?.data?.data) {
      const newIds = country?.data?.data?.map((d) => d.id);
      setAllChecked(newIds);
    }
  }, [country?.data]);

  const [add, setAdd] = useState(false);
  const [edit, setEdit] = useState(false);
  const [rdelete, setRDelete] = useState(false);
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [id, setId] = useState("");
  const [showSuccessfull, setShowSuccessful] = useState(false);

  const handlePageChange = async (page) => {
    await fetch(page);
  };

  const handleDelete = async (id) => {
    const success = await deleteData(id);
    setRDelete(false);
    if (success) setSuccess(true);
    else setErr(true);
  };

  const handleStatusChange = async (id) => {
    const success = await toggleStatus(id);
    await fetch();
    // if (success) setSuccess(true);
    // else setErr(true);
  };

  const handleStatusUpdate = async (driverId, statusId) => {
    const selectedDriverData = country?.data?.data?.find(
      (d) => d.id === driverId
    );

    try {
      const res = await dispatch(
        updateDriverStatus({
          driver_id: driverId,
          status_id: Number(statusId),
        })
      );

      if (res?.meta?.requestStatus == "fulfilled") {
        await dispatch(GetAll());
        setShowSuccessful(true);
        setSuccess(true);
        fetch();
        setTimeout(() => {
          setSuccess(false);
          setShowSuccessful(false);
        }, 3000);
      } else {
        setErr(true);
      }
    } catch (error) {
      console.error("Status update failed:", error);
      setErr(true);
    }
  };

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value))
        );
      }
    }
  };

  const HandleDownload = async () => {
    try {
      await DOWNLOAD_EXCEL(
        "/admin/driver/download",
        selectAllChecked,
        "Driver List"
      );
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <section className="content_body section_box">
      <div className="top_title_sec">
        <div className="forms_section">
          <div className="row align-items-end">
            <div className="col-md-12">
              <Section_title title={`${vehicleType} Drivers`} alltotal="" />
            </div>
            {/* <div className="col-md-5 mb-3 ps-0">
            <Table_search name={f_name} setName={setName} fetch={fetch} />
          </div> */}
            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by First Name</label>
              <Form.Control
                type="text"
                placeholder="Enter First Name"
                value={first_name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by Email</label>
              <Form.Control
                type="text"
                placeholder="Enter Email"
                value={email}
                onChange={(e) => setemail(e.target.value)}
              />
            </div>
            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by Contact Number</label>
              <Form.Control
                type="text"
                placeholder="Enter Contact Number"
                value={contact_no}
                onChange={(e) => setcontact_no(e.target.value)}
              />
            </div>
            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by Pincode</label>
              <Form.Control
                type="text"
                placeholder="Enter Pincode"
                value={pincode}
                onChange={(e) => setpincode(e.target.value)}
              />
            </div>
            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by Type</label>
              <Form.Select
                value={vehicleType}
                onChange={(e) => setVehicleType(e.target.value)}
              >
                <option value="">Select Type</option>
                <option value="Cab">Cab</option>
                <option value="Transport">Transport</option>
              </Form.Select>
            </div>
            <div className="col-md-4 mb-3" style={{ width: "fit-content" }}>
              <button
                className="btn btn-danger "
                onClick={() => {
                  setName("");
                  setemail("");
                  setcontact_no("");
                  setpincode("");
                  setVehicleType("");
                }}
              >
                Reset
              </button>
            </div>
            <div className="mb-3">
              {/* <CButton name="Reset" variant="danger" action={handleReset} /> */}
              {/* <CButton name="Add" variant="success" action={() => setAdd(true)} /> */}
              <button className="btn btn-success " onClick={HandleDownload}>
                Download Excel
              </button>
            </div>{" "}
          </div>
        </div>
      </div>
      {/* <Add id={id} setId={setId} /> */}
      <div className="table_section theme_bg">
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                {" "}
                {/* <th>
                  <input
                    type="checkbox"
                    value="selectAll"
                    checked={allChecked.length === selectAllChecked.length}
                    onChange={handleChange}
                    id="selectAll"
                    className="me-1"
                  ></input>
                  Select
                </th> */}
                <th>S. no.</th>
                <th>First Name</th>
                <th>Email</th>
                <th>Contact No</th>
                <th>Type</th>
                <th>Profile Photo</th>
                <th>Pincodes</th>
                <th className="border-none-holder">Date</th>
                <th>Driver Status</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {country?.data?.data?.length > 0 ? (
                country?.data.data?.map((val, index) => (
                  <tr key={index}>
                    {/* <td>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        value={val?.id}
                        name="perselected"
                        checked={selectAllChecked.includes(val?.id)}
                        onChange={handleChange}
                        id="flexCheckDefault"
                      />
                    </td>{" "} */}
                    <td>
                      {(country?.data?.current_page - 1) *
                        country?.data?.per_page +
                        index +
                        1}
                    </td>
                    <td>{val?.first_name}</td>
                    <td>{val?.email}</td>
                    <td>{val?.contact_no}</td>
                    <td>{val?.type}</td>
                    <td>
                      {val?.profile_photo && (
                        <img
                          src={`${IDS.IMG_URL}${val?.profile_photo}`}
                          alt="Image"
                          className="tableimg"
                          onClick={() => {
                            setModalShow(true);
                            setImage(val?.profile_photo);
                          }}
                        />
                      )}
                    </td>
                    <td>
                      <h5>
                        <span
                          data-tooltip-id={`pincode-tooltip-${val?.id}`}
                          data-tooltip-place="right"
                          className="ms-2 text-primary"
                          style={{ cursor: 'pointer' }}
                        >
                          <FontAwesomeIcon icon={faInfoCircle} />
                        </span>
                      </h5>

                      <Tooltip id={`pincode-tooltip-${val?.id}`} className="bg-white text-dark shadow">
                        <table className="table table-bordered table-sm mb-0">
                          <thead>
                            <tr>
                              <th>S. no.</th>
                              <th>Pincode</th>
                            </tr>
                          </thead>
                          <tbody>
                            {val?.DriverPincodes.map((pincode, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{pincode?.Pincode?.name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </Tooltip>
                    </td>
                    <td>
                      {new Date(val?.createdAt).toLocaleString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        // hour: "2-digit",
                        // minute: "2-digit",
                        // hour12: true,
                      })}
                    </td>
                    <td>
                      <Form.Select
                        value={val.driver_status_id}
                        onChange={(e) =>
                          handleStatusUpdate(val.id, Number(e.target.value))
                        }
                        disabled={Number(val.driver_status_id) !== 1} // Ensure type-safe comparison
                      >
                        {Number(val.driver_status_id) === 1 ? (
                          <>
                            <option value="">Select</option>
                            <option value={2}>Accepted</option>
                            <option value={3}>Rejected</option>
                          </>
                        ) : (
                          <option value={val.driver_status_id}>
                            {{
                              2: "Accepted",
                              3: "Rejected",
                            }[Number(val.driver_status_id)] || "Unknown"}
                          </option>
                        )}
                      </Form.Select>
                    </td>
                    <td>
                      <Form.Check
                        type="switch"
                        id={`custom-switch-${val?.id}`}
                        checked={val?.status}
                        onChange={() => {
                          if (
                            window.confirm(
                              `Are you sure you want to ${val?.status ? "Deactivate" : "Activate"
                              } this Driver?`
                            )
                          ) {
                            handleStatusChange(val?.id);
                          }
                        }}
                        label={val?.status ? IDS.ACTIVE : IDS.INACTIVE}
                      />
                    </td>
                    <td>
                      <div className="action_btns">
                        <button
                          className="btn view-btn btn-sm"
                          onClick={() => {
                            setSelectedDriver(val);
                            setShowModal(true);
                          }}
                        >
                          {/* View Details */}
                          <FontAwesomeIcon icon={faEye} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {selectedDriver && (
        <div
          className={`modal ${showModal ? "d-block" : "d-none"}`}
          tabIndex="-1"
        >
          <div
            className="modal-dialog modal-fullscreen-lg-down modal-xl
          "
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Driver Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <table className="table table-bordered">
                  <tbody>
                    <tr>
                      <th>Vehicle Category</th>
                      <td>
                        {selectedDriver.Driver_Detail?.Vehicle_Category?.name}
                      </td>
                    </tr>
                    <tr>
                      <th>Vehicle Name</th>
                      <td>{selectedDriver?.Driver_Detail?.Vehicle?.name}</td>
                    </tr>
                    <tr>
                      <th>Vehicle Body Type</th>
                      <td>
                        {selectedDriver?.Driver_Detail?.Vehicle_Body_Type?.name}
                      </td>
                    </tr>
                    <tr>
                      <th>Owner Number</th>
                      <td>{selectedDriver?.Driver_Detail?.owner_number}</td>
                    </tr>
                    <tr>
                      <th>Vehicle Number</th>
                      <td>{selectedDriver.Driver_Detail?.vehicle_number}</td>
                    </tr>
                    <tr>
                      <th>City</th>
                      <td>{selectedDriver.Driver_Detail?.City?.name}</td>
                    </tr>
                    <tr>
                      <th>Driver Video</th>
                      <td>{selectedDriver.training_video ? "Yes" : "No"}</td>
                    </tr>
                    <tr>
                      <th>Driver Type</th>
                      <td>{selectedDriver.type}</td>
                    </tr>
                  </tbody>
                </table>
                <hr />

                <h5>Driver Pincodes</h5>

                <div className="d-flex flex-wrap gap-2">
                  {selectedDriver?.DriverPincodes.map((pincode, index) => (
                    <div
                      key={index}
                      className="card px-3 py-1 shadow-sm"
                      style={{
                        borderRadius: "12px",
                        fontSize: "14px",
                        backgroundColor: "#f8f9fa",
                        border: "1px solid #dee2e6"
                      }}
                    >
                      {pincode?.Pincode?.name}
                    </div>
                  ))}
                </div>


                <hr />
                <h5>Driver Documents</h5>
                <div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="row">


                        {selectedDriver.Driver_Documents.map((doc) => (
                          <div className="col-md-6">
                            <div key={doc} className="mb-4">
                              <strong className="d-block mb-2">
                                {doc?.Document?.name}
                              </strong>
                              <img
                                src={`${IDS.IMG_URL}${doc.document}`}
                                alt={doc}
                                className="img-fluid rounded border"
                                style={{
                                  maxHeight: "200px",
                                  width: "100%",
                                  objectFit: "contain",
                                }}
                                onClick={() => {
                                  setImage(doc.document);
                                }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <img
                        src={`${IDS.IMG_URL}${image}`}
                        className="img-fluid rounded border"
                        style={{
                          maxHeight: "700px",
                          width: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Pagination_Holder
        onPageChange={country?.data?.current_page}
        totalPages={country?.data?.total_pages}
        handlePageChange={handlePageChange}
      />{" "}
      <Successfull_Modal
        message={"Status Successful"}
        show={showSuccessfull}
        onHide={() => setShowSuccessful(false)}
      />
      <View_img_Modal
        show={modalShow}
        image={image}
        onHide={() => setModalShow(false)}
      />
    </section>
  );
};

export default Country;
